import { Component } from '@angular/core';
import { StepperGridComponent } from '../../components/stepper-grid/stepper-grid.component';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-approve',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    SectionGridComponent, 
    FooterGridComponent,
    StepperGridComponent
  ],
  templateUrl: './create-approve.component.html',
  styleUrl: './create-approve.component.scss'
})
export class CreateApproveComponent {
  
  // Get today's date for display
  today: Date = new Date();
  
  constructor(private router: Router) {}
  
  activateCompany() {
    console.log('Activating company...');
    // Your activation logic here
    
    // Show loading or call API
    // After successful activation, navigate to dashboard
    this.router.navigate(['/dashboard']);
  }
  
  goToAcounts() {
    this.router.navigate(['company']);
  }
  
  viewCompanyDetails() {
    console.log('Viewing company details...');
    // Navigate to company details page or open modal
    // this.router.navigate(['/company/details']);
  }
}
